import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/layout';
import TopbarBackground from '../components/topbarBackground';
import TermsPrivacyAndGDPR from '../containers/SaasModern/TermsPrivacyAndGDPR';
import SLA from '../containers/SaasModern/SLA';

const GetComponent = ({ path, html, children }) => {
  switch (path) {
    case '/terms':
    case '/privacy':
    case '/gdpr':
      return <TermsPrivacyAndGDPR>{children}</TermsPrivacyAndGDPR>;
    case '/sla':
    case '/esla':
      return <SLA>{children}</SLA>;
    default:
      return <div>404 {path}</div>;
  }
};

export default function Template({
  data, // this prop will be injected by the GraphQL query below.
}) {
  const { markdownRemark } = data; // data.markdownRemark holds our post data
  const { frontmatter, html } = markdownRemark;
  const component = <getComponent path={frontmatter.path} html={html} />;
  return (
    <Layout>
      <TopbarBackground />
      {/* <div className="blog-post-container">
        <div className="blog-post">
          <h1>{frontmatter.title}</h1>
          <h2>{frontmatter.date}</h2>
          <div
            className="blog-post-content"
            dangerouslySetInnerHTML={{ __html: html }}
          />
        </div>
      </div> */}
      <GetComponent path={frontmatter.path} html={html}>
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </GetComponent>
    </Layout>
  );
}

export const pageQuery = graphql`
  query($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        path
        title
      }
    }
  }
`;
